<template>
	<div class="navbar-custom">
		<ul class="list-unstyled topbar-menu float-end mb-0 d-flex align-items-center">
			<li class="dropdown notification-list d-lg-none">
				<a
					class="nav-link dropdown-toggle arrow-none"
					data-bs-toggle="dropdown"
					href="#"
					role="button"
					aria-haspopup="false"
					aria-expanded="false"
				>
					<i class="dripicons-search notif-icon"></i>
				</a>
				<div class="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
					<form class="p-3">
						<input
							type="text"
							class="form-control"
							placeholder="Search ..."
							aria-label="Recipient's username"
						/>
					</form>
				</div>
			</li>

			<!-- notif -->
			<li class="dropdown">
				<notifications :is-admin-nav="true"></notifications>
			</li>
			<!-- User profile -->
			<li class="dropdown notification-list">
				<Dropdown class-label="nav-link  nav-user arrow-none me-0" class-menu="profile-dropdown">
					<template #label>
						<span class="account-user-avatar">
							<img
								:src="avatarImage"
								alt="user-image"
								class="rounded-circle"
							/>
						</span>
						<span>
							<span class="account-user-name">{{ user.name }}</span>
							<span class="account-position text-capitalize">{{ user.role }}</span>
						</span>
					</template>
					<template #menu>
						<div class="dropdown-item notify-item cursor-pointer" @click="handleLogout">
							<i class="bi bi-box-arrow-right mr-1"></i>
							<span>Logout</span>
						</div>
					</template>
				</Dropdown>
			</li>
		</ul>
		<button class="button-menu-mobile open-left" @click="toggleSidebar">
			<i class="bi bi-list"></i>
		</button>

		<!-- <div class="app-search dropdown d-none d-lg-block">
			<form @submit.prevent="search">
				<div class="input-group">
					<input
						v-model="keyword"
						type="text"
						class="form-control"
						placeholder="Nomor Resi, Nama atau Telepon"
					/>
					<span class="mdi mdi-magnify search-icon"></span>
				</div>
			</form>
		</div> -->
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Dropdown from '@/components/parts/Dropdown.vue';
import Notifications from '@/components/Notifications.vue';

export default {
	name: 'Header',
	components: {
		Dropdown,
		Notifications,
	},
	data() {
		return {
			shrink: false,
			keyword: '',
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		avatarImage() {
			return `https://ui-avatars.com/api/?name=${this.user.name}&background=random&size=128`;
		},
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		...mapActions({
			toggleSidebar: 'toggleSidebar',
			logout: 'logout',
		}),
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			this.shrink = scrollPosition > treshold;
		},
		dismiss() {
			this.dismissNotice();
		},
		handleLogout() {
			this.logout();
		},
		search() {
			this.$router.push({
				name: 'orders',
				query: { keyword: this.keyword },
			});
		},
	},
};
</script>
